import React, {Component} from 'react';
import eventEmitter from "./Modal";
import { IShow, MODAL_HIDE, MODAL_SHOW, ModalItem, ModalState } from "./ModalTypes";
import * as Modal from "./Modal";

type Props = {};

/**
 * manager pro zobrazování dialogů.
 */
export class ModalManager extends Component<Props, ModalState> {
    constructor(props: Props) {
        super(props);

        this.state = {
            components: [],
        };

        eventEmitter.addListener(MODAL_SHOW, this.modalShow);
        eventEmitter.addListener(MODAL_HIDE, this.modalHide);
    }

    modalHide = () => {
        const {components} = this.state;
        this.setState({
            components: [...components.slice(0, components.length - 1)],
        });
    };
    modalShow = (event: IShow) => {
        const {components} = this.state;
        const {component, componentProps} = event;
        this.setState({
            components: [
                ...components,
                {
                    component,
                    componentProps,
                },
            ],
        });
    };

    getCurrentComponent = (): ModalItem | null => {
        const {components} = this.state;
        const c = components[components.length - 1];
        if (!c) {
            console.error('Komponenta není definovaná.' + ' Je možné, že voláte onClose z unmountnuté komponenty např. kvůli nezrušenému history.listen');

            return null;
        }
        return c;
    };

    handleClose = (e?: React.MouseEvent<HTMLElement>) => {
        const c = this.getCurrentComponent();
        if (c === null) {
            return;
        }

        // Custom on close
        let onClose;
        if (c && c.componentProps && c.componentProps.onClose) {
            onClose = c.componentProps.onClose;
        } else {
            onClose = undefined;
        }

        let defaultPrevented = false;
        onClose &&
            onClose({
                ...(e || {} as React.MouseEvent<HTMLElement>),
                preventDefault: () => {
                    defaultPrevented = true;
                    e && e.preventDefault();
                },
                stopPropagation: () => {
                    defaultPrevented = true;
                    e && e.stopPropagation();
                },
            } as React.MouseEvent<HTMLElement>);
        if (!defaultPrevented) {
            Modal.hide();
        }
    };

    render() {
        const {components} = this.state;

        if (components.length === 0) {
            return <></>;
        }

        const dialogs = components.map((c, index) => {
            let element = React.createElement(c.component, {
                ...c.componentProps,
                key: 'modal-' + index,
                onClose: this.handleClose,
            });
            return element;
        });

        return <>{dialogs}</>;
    }
}
